"use client";

import { useEffect } from "react";
import { frontendImage } from "@/lib/helpers";
import Image from "next/image";
import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "./_hooks/useSection";
import BestSolutionsSkeleton from "./_skeletons/BestSolutionsSkeleton";
import Link from "next/link";
import { motion } from "framer-motion";

export const MoreSolutions = () => {
  const { trans } = useUtility();
  const { content, elements, loading } = useSection("best_solutions");

  if (loading) {
    return <BestSolutionsSkeleton />;
  }

  const solutionsData = [
    {
      id: 1,
      title: "Add & Send",
      description: "Add funds to your wallet and Send Smiles!",
      image:
        "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754917836/Frame_1618870273_rgzx1c.png",
      className: "more--solutions__card--blue",
    },
    {
      id: 2,
      title: "Convert",
      description: "Unlock the best exchange rates",
      image:
        "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918123/image_148_hxcpdq.png",
      className: "more--solutions__card--orange",
    },
    {
      id: 3,
      title: "Explore",
      description: "Buy airtime, buy data, pay bills and more...",
      image:
        "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918123/image_149_w6nqjs.png",
      className: "more--solutions__card--gray",
    },
  ];

  return (
    <motion.div
      className="more--solutions"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
    >
      <motion.div
        className="more--solutions__container"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.1 }}
      >
        <motion.div
          className="more--solutions__header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <span className="best-solution-shape">
            <Image
              src={frontendImage(content?.star_icon, "best_solutions")}
              alt="Decorative Shape"
              width={52}
              height={55}
              layout="responsive"
            />
          </span>
          <div className="more--solutions__badge">
            <span>More for you</span>
          </div>
          <motion.h2
            className="more--solutions__title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.3 }}
          >
            Just enough to
            <br />
            get you going everyday
          </motion.h2>
        </motion.div>

        <div className="more--solutions__cards">
          {solutionsData.map((solution, index) => (
            <motion.div
              key={solution.id}
              className={`more--solutions__card ${solution.className}`}
              initial={{ opacity: 0, x: index === 2 ? 40 : -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.4 + index * 0.15 }}
            >
              <div className="more--solutions__card-image">
                <Image
                  src={solution.image}
                  alt={solution.title}
                  width={265}
                  height={273}
                  className="more--solutions__image"
                  unoptimized
                />
                {/* Absolute positioned images only for the last card (Explore) */}
                {index === 2 && (
                  <>
                    <div className="more--solutions__card-overlay-image-1">
                      <Image
                        src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1753561754/Frame_635380_idmxsb.png"
                        alt="Overlay Image 1"
                        width={103}
                        height={80}
                        className="more--solutions__overlay-image"
                      />
                    </div>
                    <div className="more--solutions__card-overlay-image-2">
                      <Image
                        src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1753561754/Frame_635377_kuw77g.png"
                        alt="Overlay Image 2"
                        width={103}
                        height={60}
                        className="more--solutions__overlay-image"
                      />
                    </div>
                  </>
                )}
              </div>
              <div
                className={`more--solutions__card-content ${index === 1 ? "more--solutions__card-content-orange" : ""}`}
              >
                <h3 className="more--solutions__card-title">
                  {solution.title}
                </h3>
                <p className="more--solutions__card-description">
                  {solution.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};
